{
    "translation": {
        "invoices": {
            "note": "Dear customer, if you are a card paying customer, please disregard this invoice."
        },
        "flowPicker": {
            "title": "Are you a new or existing Flex customer?",
            "newCustomer": "I want to become a Flex customer",
            "existingCustomer": "I already have a Flex subscription",
            "nextButton": "Go ahead"
        },
        "lisaAnd": {
            "plans": {
                "selectSubscription": "Select subscription",
                "description": "",
                "VALUE": {
                    "title": "Flex 24 months",
                    "description": "Switch or terminate after 24 months."
                },
                "FLEX": {
                    "title": "Full Flex",
                    "description": "Switch or exit whenever you want",
                    "priceDescription": "for {{months}} months.\nThereafter {{price}}"
                },
                "disclaimer": "In the case of trade-in, the price applies to an approved trade-in in the specified condition.",
                "welcomeMessage": {
                    "title": "Terms of Samsung Flex",
                    "paragraphs": [
                        "Samsung Flex is a service which means that you as a private person have the opportunity to rent Samsung products from our partner Lisa&.",
                        "You pay a monthly fee instead of the full cost outright or in installments, and when you finish, you return your device. This gives you the flexibility to switch devices at your own pace.",
                        "Choose between a fixed period of 24 months or Full flexibility.",
                        "See full terms and conditions here."
                    ]
                }
            },
            "cart": {
                "discount": "Discount",
                "priceFor": "{{price}} \nfor {{months}} months",
                "monthlyCost": "Your monthly cost",
                "accessories": "Accessories",
                "prepayToday": "Amount to pay today",
                "prepayTodayDisclaimer": "{{months}} monthly fee and any accessories",
                "showDiscount": "Show discount",
                "tradeInEstimate": "Estimated value for Trade-in",
                "VALUE": {
                    "planName": "FIXED"
                },
                "FLEX": {
                    "planName": "FLEXIBLE"
                },
                "totalMonthlyDiscount": "<0>Total monthly discount (1-{{months}}): <1></1></0>",
                "totalMonthlyDiscountIncludesBoth": "<0>The discount includes both the estimated trade-in bonus and other discounts</0>"
            }
        },
        "general": {
            "readMore": "Read more",
            "images_zero": "",
            "images_one": "1 image",
            "images_other": "{{count}} images",
            "edit": "Edit",
            "cancel": "Cancel",
            "save": "Save",
            "close": "Close",
            "view": "View",
            "back": "Back",
            "errors": {
                "required": "This field is required"
            }
        },
        "svea": {
            "genericDiscount": "Discount",
            "tradeinSubsidy": "Trade-in subsidy",
            "tradeinSubsidyPlaceholderReversal": "Trade-in adjustment",
            "tradeinName": "Trade-in discount",
            "upfrontPaymentProduct": "Prepaid: ",
            "upfrontPaymentProductDiscount": "Prepaid: ",
            "upfrontPaymentTradeInDiscount": "Prepaid: ",
            "reversal": "Reversal: "
        },
        "header": {
            "debug": "Debug",
            "back": "Back",
            "backLink": "https://shop.samsung.com/se/cart",
            "help": "In case of questions, please call 061967755511",
            "helpLink": "tel:061967755511",
            "toggleLabel": "Menu",
            "home": "Home",
            "login": "Login",
            "loginSubtitle": "Login subtitle",
            "loginButton": "Submit",
            "logOut": "Log out",
            "subscriptions": "My Subscriptions",
            "invoices": "Invoices",
            "offers": "Offers",
            "account": "My Account",
            "language": {
                "options": {
                    "fi-FI": "Finnish",
                    "sv-SE": "Swedish",
                    "no-NO": "Norwegian",
                    "nb-NO": "Norwegian",
                    "da-DK": "Danish"
                },
                "label": "Choose language",
                "labelDescription": "",
                "selectLabel": "Language selector"
            }
        },
        "banner": {
            "title": "Welcome to the future with Samsung Flex",
            "subTitle": ""
        },
        "footer": {
            "language": "UK/English",
            "languageLink": "https://www.samsung.com/function/ipredirection/ipredirectionLocalList/",
            "backToTop": "Back to top",
            "topNote": {
                "text": "If you have any questions about the program or to speak with customer service, please contact Samsung at 080 077 31 77.",
                "button": {
                    "text": "Call customer support 080 077 31 77",
                    "url": "tel:080 077 31 77"
                }
            },
            "copyright": "Copyright© 1995-{{currentYear}} Samsung. All rights reserved",
            "termsAndConditions": "",
            "termsAndConditionsLink": "",
            "social": {
                "title": "Follow us on",
                "items": [
                    {
                        "text": "facebook",
                        "url": "#"
                    },
                    {
                        "text": "twitter",
                        "url": "#"
                    },
                    {
                        "text": "instagram",
                        "url": "#"
                    },
                    {
                        "text": "linkedin",
                        "url": "#"
                    },
                    {
                        "text": "youtube",
                        "url": "#"
                    },
                    {
                        "text": "community",
                        "url": "#"
                    }
                ]
            },
            "terms": [
                {
                    "text": "Contact",
                    "url": "#"
                },
                {
                    "text": "Accessibility",
                    "url": "#"
                },
                {
                    "text": "Legal",
                    "url": "#"
                },
                {
                    "text": "Privacy",
                    "url": "#"
                },
                {
                    "text": "Sitemap",
                    "url": "#"
                },
                {
                    "text": "Terms & Condition",
                    "url": "#"
                }
            ],
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "080 077 31 77",
                            "url": "tel:080 077 31 77"
                        },
                        {
                            "text": "ma-pe | 08:00 - 20:00"
                        },
                        {
                            "text": "la | 10:00 - 15:00"
                        },
                        {
                            "text": "su | 10:00 - 15:00"
                        }
                    ]
                },
                {
                    "title": "Tietoja Samsung Flex",
                    "text": "Foxway tarjoaa yksityishenkilöille mahdollisuuden vuokrata ja ostaa matkapuhelimia, joita Samsung Electronics Nordic AB tarjoaa vuokralle ja ostettavaksi Samsung Flex puitteissa.\nLisätietoja ja täydelliset huvilat, katso https://www.samsung.com/fi/flex",
                    "links": []
                },
                {
                    "title": "Tietoja Foxway",
                    "text": "Yrityksen nimi: Foxway Finance AB, Filial i Finland\nOrganisaation numero: 2762890-6\nSähköpostiosoite: subscriptions@foxway.com\nKäyntiosoite: Grusåsvägen 7, 352 45 Växjö\nPostiosoite: Grusåsvägen 7, 352 45 Växjö\nALV rekisteri numero: FI27628906",
                    "links": [
                        {
                            "text": "Katso käyttöehdot kokonaisuudessaan",
                            "url": "https://resellers.foxway.com/subscriptionterms-fi",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Tietoja Samsung",
                    "text": "Yrityksen nimi: Samsung Electronics Nordic AB\nOrganisaation numero: 556445-4345\nYhteystiedot: https://www.samsung.com/fi/support/contact/\nKäyntiosoite: Vaisalantie 4, 02130 Esbo, Soumi\nPostiosoite: Box 1235, 164 28 Kista, Sweden\nALV rekisteri numero: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "portalFooter": {
            "backToTop": "Back to top",
            "copyright": "The customer portal and other services related to Samsung Flex are provided by Foxway. Copyright © 1995-{{currentYear}} Samsung. All rights reserved.",
            "items": []
        },
        "plans": {
            "tradeInTitle": "Estimated trade-in discount:",
            "tradeIn": "{{amount}}/month | {{duration}} months",
            "closeModal": "Close",
            "selectSubscription": "Select subscription",
            "description": "Samsung Flex - Select between Full Flex (trade-in / upgrade when you want) or {{months}} months (trade-in / upgrade after {{months}} months). Product protection is included.",
            "plans": {
                "EMPTY": {
                    "title": "-",
                    "description": "",
                    "descriptionOne": "",
                    "descriptionTwo": "",
                    "descriptionThree": ""
                },
                "FLEX": {
                    "title": "Full Flexibility",
                    "description": "",
                    "descriptionOne": {
                        "title": "Trade-in / Upgrade when you want",
                        "tooltip": "Yorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus."
                    },
                    "descriptionTwo": {
                        "title": "Product protection is included",
                        "tooltip": "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex. Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia. Aliquam in elementum tellus.",
                        "modal": {
                            "trigger": "Läs mer",
                            "paragraphs": [
                                {
                                    "title": "Lorem ipsum",
                                    "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi fermentum enim velit, nec dapibus ante mollis a. Sed ut sem tortor. Aenean consectetur, tellus in ultrices porta, metus mauris fringilla lacus, id fringilla ante velit et augue."
                                },
                                {
                                    "title": "Quisque mi massa",
                                    "content": "Ut mollis ultricies gravida. Praesent sit amet pretium lacus, eu varius massa. Pellentesque a fringilla elit. Nulla et urna et neque tempor dapibus vitae vitae ex. Duis suscipit commodo molestie. Sed egestas nibh sed enim ornare, ut eleifend urna maximus."
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "No hidden costs",
                        "tooltip": "Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia. Aliquam in elementum tellus.",
                        "modal": {
                            "trigger": "Läs mer",
                            "paragraphs": [
                                {
                                    "title": "Quisque faucibus efficitur purus.",
                                    "content": "Etiam finibus nec arcu quis luctus. Proin aliquam est leo, non mollis nunc pharetra at. Vivamus condimentum nibh sed sollicitudin mattis."
                                },
                                {
                                    "content": "Sed at finibus magna. Proin tellus nibh, mattis a nunc id, gravida molestie metus. Donec quis erat rutrum, aliquet elit et, sollicitudin metus. Praesent rutrum a est malesuada commodo."
                                }
                            ]
                        }
                    },
                    "priceDescription": "{{basePrice}} after {{months}} months",
                    "accordion": {
                        "title": "Full flexibilitet",
                        "paragraphs": [
                            {
                                "title": "Samsung Galaxy till en fast månadskostnad",
                                "content": "När du väljer Full Flexibilitet kan du komma och gå som du vill, prenumerationen lever upp till sitt namn. Du är Fullt Flexibel. Du använder telefonen så länge du vill och skickar sedan tillbaka den till vår partner Foxway när det är dags att uppgradera, byta eller avsluta."
                            },
                            {
                                "title": "Byt eller uppgradera när du vill",
                                "content": "När du väljer Full Flexibilitet kan du komma och gå som du vill, prenumerationen lever upp till sitt namn. Du är Fullt Flexibel. Du använder telefonen så länge du vill och skickar sedan tillbaka den till vår partner Foxway när det är dags att uppgradera, byta eller avsluta."
                            },
                            {
                                "title": "Avsluta när du vill",
                                "content": "När bindningstiden närmar sig slutet kommer du att bli kontaktad av Samsung för att göra ditt val. Om du vill uppgradera till en ny Samsung Galaxy beställer du först din nya telefon på Samsung.com."
                            },
                            {
                                "title": "Om din enhet skadas",
                                "content": "Du är skyldig att vårda och underhålla enheten som Foxway tillhandahåller genom Samsung Flex. Om enheten skadas eller försvinner måste du ersätta Foxway för den skada som orsakats Foxway."
                            }
                        ]
                    }
                },
                "VALUE": {
                    "title": "Fixed contract {{months}} months",
                    "descriptionOne": {
                        "title": "Trade-in / Upgrade when you want",
                        "tooltip": "Yorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus."
                    },
                    "descriptionTwo": {
                        "title": "Product protection is included",
                        "tooltip": "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus ex. Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia. Aliquam in elementum tellus.",
                        "modal": {
                            "trigger": "Läs mer",
                            "paragraphs": [
                                {
                                    "title": "Lorem ipsum",
                                    "content": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi fermentum enim velit, nec dapibus ante mollis a. Sed ut sem tortor. Aenean consectetur, tellus in ultrices porta, metus mauris fringilla lacus, id fringilla ante velit et augue."
                                },
                                {
                                    "title": "Quisque mi massa",
                                    "content": "Ut mollis ultricies gravida. Praesent sit amet pretium lacus, eu varius massa. Pellentesque a fringilla elit. Nulla et urna et neque tempor dapibus vitae vitae ex. Duis suscipit commodo molestie. Sed egestas nibh sed enim ornare, ut eleifend urna maximus."
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "No hidden costs",
                        "tooltip": "Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel bibendum lorem. Morbi convallis convallis diam sit amet lacinia. Aliquam in elementum tellus.",
                        "modal": {
                            "trigger": "Läs mer",
                            "paragraphs": [
                                {
                                    "title": "Quisque faucibus efficitur purus.",
                                    "content": "Etiam finibus nec arcu quis luctus. Proin aliquam est leo, non mollis nunc pharetra at. Vivamus condimentum nibh sed sollicitudin mattis."
                                },
                                {
                                    "content": "Sed at finibus magna. Proin tellus nibh, mattis a nunc id, gravida molestie metus. Donec quis erat rutrum, aliquet elit et, sollicitudin metus. Praesent rutrum a est malesuada commodo."
                                }
                            ]
                        }
                    }
                }
            },
            "selected": "Selected",
            "select": "Select",
            "minimumTotalCost": "Minimum total cost\n{{cost}}"
        },
        "sign": {
            "acceptTermsLabel": "Terms and conditions",
            "acceptTerms": "By choosing to receive marketing messages from Samsung, we will share information about you and your order with Samsung Electronics (UK) Limited and Samsung Electronics Co., Ltd. (Korea) <1>In accordance with Samsung's Global Privacy Policy.</1> We, Samsung Electronics Nordic AB of the above Samsung entities on behalf of you, we provide you with customized advertising, news, special offers and other information about Samsung and its partners' products and services via email, text messages and notifications. You can unsubscribe from messages at any time in your Samsung account settings or by clicking \"Unsubscribe here\" at the bottom of the newsletter.",
            "acceptTermsLink": "https://www.samsung.com/fi/info/privacy/",
            "title": "Personal information",
            "firstName": "Firstname",
            "lastName": "Surname",
            "email": "Email",
            "phone": "Telephone number",
            "postalCode": "Postal code",
            "address": "Address",
            "city": "City",
            "errors": {
                "firstName": "Invalid First name",
                "lastName": "Invalid Surname",
                "lastNameTooBig": "The maximum number of characters is 40. Please remove first names and other names that are not in daily use.",
                "firstNameTooBig": "The maximum number of characters is 40. Please remove first names and other names that are not in daily use.",
                "email": "Invalid Email",
                "phone": "Invalid Telephone number",
                "postalCode": "Invalid Postal code",
                "address": "Invalid Address",
                "city": "Invalid City"
            },
            "steps": {
                "yourInfo": "Your info",
                "sign": "Sign",
                "confirmation": "Confirm"
            },
            "delivery": "Delivery",
            "differentShippingAddress": "My shipping address is different from my invoicing address.",
            "deliveryMethods": {
                "se-sena-hd-parcel-postnord": {
                    "name": "Postnord hemleverans",
                    "description": "Leverans inom 1-3 dagar. Vissa \npostnummer kan längre leveranstid.\nPostnord aviserar dig via SMS under \ntransporten med beräknad leveransdag \noch -tid.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                },
                "no-sena-hd-mxparcel-bring": {
                    "name": "Levering med Bring",
                    "description": "Normal leveringstid  er 1-5 virkedager",
                    "cartTitle": "Levering med Bring",
                    "price": "Gratis"
                },
                "no-sena-hd-parcel-dhl": {
                    "name": "Hjemlevering (pakke) - DHL",
                    "description": "Leveringstid ved hjemlevering (pakke) er 1-5 arbeidsdager. \nYtterligere leveringstid til visse postnumre kan påløpe.\nTransportøren meddeler deg via SMS under transporten med \nanslått leveringsdato og tid.",
                    "cartTitle": "DHL Express hemleverans",
                    "price": "Kostnadsfri"
                },
                "no-sena-pick-up-point": {
                    "name": "Fremsending - Bring",
                    "description": "I hovedsak 1–3 virkedager avhengig av strekning.\n4–5 dager til enkelte destinasjoner. \nE-varsling (sms/e-post) uten tillegg i prisen forutsetter \nat vi har mobilnummer eller e-postadresse. ",
                    "cartTitle": "Bring pickup",
                    "price": "Kostnadsfri"
                },
                "dk-sena-hd-parcel-postnord": {
                    "name": "Hjemmelevering (pakker) - Postnord",
                    "description": "Levering inden for 1-5 hverdage.\nDer kan være længere leveringstid ved levering til visse \npostnumre. \nTransportøren giver dig besked via SMS under transporten med \nanslået leveringsdato og -tidspunkt.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                },
                "fi-sena-hd-parcel-postnord": {
                    "name": "Kotiinkuljetus (paketti) – Postnord",
                    "description": "Toimitusaika 1-5 arkipäivää.\nToimitusaika saattaa olla pidempi tiettyjen postinumeroiden.\nLiikenteenharjoittajan tulee ilmoittaa sinulle tekstiviestitse \narvioitu toimituspäivä ja -aika kuljetukselle.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                }
            }
        },
        "authStep": {
            "title": "Select authentication",
            "subtitle": "",
            "authenticationMethod": "Authentication method",
            "terms": "I accept that my information will be submitted to <1>lorem ipsum dolor sit</1> for credit check report.",
            "termsLink": "#",
            "pepTerms": "I hereby confirm that I am not a politically exposed person (PEP), and that I am not a family member or known associate of a politically exposed person.\n",
            "loginWith": "Log in with"
        },
        "validationStep": {
            "title": "Credit check",
            "subtitle": "We need to run a credit check. Please follow the instructions below.",
            "loadingText": "We are running the credit check, it will take a couple of minutes. Please wait you will be automatically redirected to the next step."
        },
        "creditCheckStep": {
            "title": "Credit check",
            "subtitle": "We need to run a credit check",
            "terms": "I accept that my information will be submitted to <1>lorem ipsum dolor sit</1> for credit check report.",
            "termsLink": "https://www.foxway.com/en/integritetspolicy/",
            "personalNumber": "Personal number",
            "errors": {
                "personalNumber": "Invalid personal number"
            }
        },
        "existingSubscriptionStep": {
            "title": "You have a current Samsung subscription",
            "description": "Do you want to upgrade your current device subscription or add a new subscription?",
            "buttonText": "Add a new subscription",
            "infoText": "To change plan on current subscriptions, please contact customer service tel 077-140 10 44 for assistance.",
            "flexTitle": "Samsung Flex",
            "valueTitle": "Samsung Value",
            "eligibleFrom": "Eligible for upgrade from <bold>{{date}}</bold>",
            "planMismatchDisclaimer": "Can only be upgraded into <bold>{{name}}</bold>",
            "activeFrom": "Delivered at <bold>{{date}}</bold>",
            "upgrade": "Upgrade",
            "upgradeNotEligible": {
                "date": "Not possible to upgrade yet. See date from when you can upgrade above.",
                "contactSupport": "Not possible to upgrade. Please contact customer support.",
                "pendingUpgrade": "This subscription already has a signed upgrade.",
                "activeClaim": "Not possible to upgrade due to an ongoing support case",
                "deviceNotReturned": "Not possible to upgrade. We are waiting on another device from you.",
                "paymentPending": "This subscription already has a signed upgrade with a pending payment. You can continue it here: ",
                "link": "link"
            }
        },
        "cart": {
            "disclaimer": "Trade-in value is an estimate, final value will be determined after trade-in is received and inspected",
            "tradeInTitle": "Samsung Trade-in",
            "tradeInValue": "Trade-in value",
            "tradeInMonthlyDiscount": "Monthly trade-in discount",
            "prepayToday": "Paid today",
            "prepay": "Upfront payment is payed today",
            "discountDuration": "discount for {{months}} months",
            "includesDiscount": "including your {{discount}}",
            "cart": "Cart",
            "overview": "Overview",
            "oneTimeCost": "Onetime cost",
            "oneTimeCostAccessories": "Onetime cost - Accessories",
            "seeDetailsBelow": "See details below",
            "authentication": "Authentication",
            "reviewAndSign": "Review and Sign",
            "continue": "Continue",
            "paymentMethod": "Payment method",
            "invoice": "Invoice",
            "minimumTotalCost": "Minimum total cost",
            "monthlyCost": "Monthly cost",
            "monthlyCostWithoutDiscount": "Monthly cost without discount",
            "generalDiscount": "General discount",
            "specialPriceTitle": "First {{specialPriceLength}} months, which after {{priceGross}} {{currencyMonthly}}",
            "creditCheck": "Run credit check",
            "fraudProtection": "Please wait",
            "emptyText": "Please choose a subscription package to continue",
            "noticeText": "By adding my payment method, I accept that Foxway automatically and in advance may charge all costs payable to Foxway."
        },
        "currency": {
            "perMonth": "per month",
            "feeForMonths": "{{fee}} for {{months}} months"
        },
        "errorPages": {
            "accessory": {
                "title": "Accessory error title",
                "button": "Accessory error button",
                "content": "Accessory error content"
            },
            "general": {
                "title": "Error",
                "button": "Back to cart",
                "content": "<1><2>Hi, unfortunately something went wrong.</2></1><3>If you have any questions, please contact our finance partner Lisa&.</3>"
            },
            "auth": {
                "title": "Authentication error",
                "button": "Back to cart",
                "content": "<1><2>Hi, unfortunately authentication failed.</2></1><3>If you have any questions, please contact our finance partner Lisa&.</3>"
            },
            "creditCheck": {
                "title": "Credit check not approved",
                "button": "Back to cart",
                "contentFailed": "Your application has been rejected as it does not meet our financing partner's criteria for this product. For more information, you are welcome to contact our customer support.",
                "contentTryAgain": "Your application has been declined because the bank or account you selected does not appear to be your main account. Please go back and apply using your primary bank account."
            }
        },
        "errors": {
            "generic": "Something went wrong, please try again",
            "authenticationError": "Authentication error",
            "scrive": {
                "authenticationError": "Something caused an authentication error. Please try again"
            },
            "svea": {
                "general": "",
                "underAge": "",
                "overAge": "",
                "numberOfAllowedSubscriptions": ""
            },
            "nicknameChangeError": "Nickname must be between 1 and 40 characters"
        },
        "portal": {
            "fraudulentCustomer": "Your account is under review. Please contact support for assistance. Some account actions may be temporarily restricted",
            "payingIssuesCustomer": "Your account is under review. Please contact support for assistance. Some account actions may be temporarily restricted",
            "dashboard": {
                "title": "Welcome, "
            },
            "invoiceStatus": {
                "due": "Payment due",
                "allPaid": "All paid up!",
                "dueOn": "Payment due on <2>{{date}}</2>.",
                "nextPayment": "Next payment due on <2>{{date}}</2>.",
                "noNextPayment": "No next payment.",
                "button": "View all invoices"
            },
            "products": {
                "nickname": "{{firstName}}'s phone"
            },
            "invoice": {
                "status": {
                    "outstanding": "Outstanding",
                    "partiallyPaid": "Partially paid",
                    "paid": "Paid",
                    "terminated": "Terminated",
                    "unknown": "Unknown",
                    "credited": "Credited"
                }
            },
            "invoices": {
                "title": "Invoices",
                "tableHeader": ["Invoice ID", "Description", "Period", "Due data", "Amount", "Status"],
                "viewInvoice": "View Invoice",
                "viewInvoices": "View Invoices",
                "loadMore": "Load more",
                "accordion": {
                    "title": "",
                    "text": ""
                },
                "status": {
                    "outstanding": "Outstanding",
                    "partiallyPaid": "Partially paid",
                    "paid": "Paid",
                    "terminated": "Terminated",
                    "unknown": "Unknown"
                },
                "noInvoices": "No invoices"
            },
            "billingAlert": {
                "generic": {
                    "before": "Your payment method is about to expire. ",
                    "link": "Update payment method",
                    "after": ""
                },
                "detailed": {
                    "before": "Your payment method is about to expire. In order to further use our services after {{dueDate}} please ",
                    "link": "update your payment method",
                    "after": "."
                }
            }
        },
        "profile": {
            "title": "My Account",
            "contactInformation": {
                "title": "Contact information",
                "firstName": "First name",
                "lastName": "Last name",
                "email": "Email",
                "phone": "Telephone number"
            },
            "billingInformation": {
                "title": "Billing information",
                "card": "Card",
                "expires": "Expires",
                "updatePaymentMethod": "Update payment method",
                "methodUpdateDescription": "Payment method update",
                "noInfo": "No billing information available"
            },
            "address": {
                "title": "Address",
                "postalCode": "Postal code",
                "address": "Address",
                "city": "City",
                "saveButton": "Save address"
            },
            "notificationPreferences": {
                "marketingModal": {
                    "title": "Marketing communication",
                    "content": "I want information about Samsung products and possibility to prebook these"
                },
                "title": "Notification preferences",
                "marketingEmails": "Marketing communication",
                "marketingEmailsLabel": "I want information about Samsung products and possibility to prebook these"
            },
            "contactInformationDisclaimer": {
                "title": "Your contact information",
                "card": {
                    "title": "Your contact information",
                    "description": "Your personal information is retrieved automatically from lorem ipsum and can not be changed. If this information is not correct please contact:",
                    "link": "email@samsung.com",
                    "linkUrl": "mailto:email@samsung.com"
                }
            }
        },
        "offers": {
            "title": "Offers"
        },
        "upgrade": {
            "title": "Upgrade"
        },
        "faq": {
            "title": "Frequently Asked Questions",
            "items": [
                {
                    "id": "samsung-flex",
                    "label": "What is Samsung Flex",
                    "children": "Samsung Flex is a service for you who would rather have a fixed monthly cost and regularly keep yourself updated instead of buying your Samsung Galaxy separately. Samsung Flex is available in two variants, Full Flexibility which gives you the freedom to change, upgrade or terminate whenever you want or 24 months where you pay a lower monthly cost and have your phone a little longer. Access to swap service applies to both."
                },
                {
                    "id": "samsung-flex-vs-buying",
                    "label": "How is Samsung Flex different from buying a device outright or in installments?",
                    "children": "..."
                }
            ]
        },
        "subscription": {
            "tradeInReimbursement": "Refund of remaining trade-in balance",
            "flexSubscriptionFee": "Flex subscription fee",
            "depositAndAccessoryPayment": "Deposit and accessory payment",
            "upfrontPayment": "First month & accessories payment",
            "endedDate": "Ended <1></1>",
            "upgradeFrom": "Eligible for upgrade from <1></1>",
            "contractSigned": "Contract signed",
            "contractStarted": "Subscription started",
            "contractEnded": "Subscription ended",
            "upgradeAnyTime": "Upgrade at any time",
            "imeiCopy": "IMEI copied to clipboard!",
            "viewContract": "View contract",
            "viewInvoice": "View invoice",
            "viewInvoices": "View Past Invoices",
            "manageSubscription": "Manage My Subscription",
            "flexTitle": "Your Full Flex subscriptions",
            "valueTitle": "Your 24 month subscriptions",
            "devicesTitle": "My Previous Devices",
            "subscriptionsTitle": "My Subscriptions",
            "addNewSubscription": "Add New Subscription",
            "addNewSubscriptionLink": "https://shop.samsung.com/",
            "swapService": "Swap Service",
            "insuranceService": "Create Insurance Case",
            "deviceDamagedConditionTermsLink": "#",
            "deviceDamagedConditionTerms": "<0>Om Enheten skadas eller försvinner måste du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du en begränsad skadeavgift för att få en ersättningsenhet. Avgiften varierar beroende på vilken modell du har. Fyll i frågorna nedan för att anmäla en skada och få Foxways bedömning om din skada kvalificerar dig för en Swap service.</0><1>Om din enhet blir stulen eller tappas bort erbjuder Foxway dig att betala en avgift för att ersätta telefonen. Avgiften motsvarar marknadsvärde vid tidpunkten. Kontakta kundservice för att anmäla en borttappad telefon.</1><2>Se fullständiga villkor för Swap service här</2>",
            "nickname": {
                "title": "Edit",
                "nickname": "Nickname",
                "description": "You can add a small description to your device to differentiate similar ones from each other. A good example is to add a nickname like “Nicks Phone”."
            },
            "payPendingPayment": "Pay",
            "pendingPaymentsTitle": "Pending",
            "tags": {
                "upgradeTo": "Upgrading to",
                "upgradeFor": "Being delivered to replace",
                "beingDelivered": "Being delivered to replace",
                "pendingPayemnt": "Signed but pending payment"
            },
            "cancel": {
                "title": "Cancel subscription",
                "unavailableNotification": {
                    "title": "Cancelling your subscription",
                    "content": "Your subscription is not eligible for cancellation at this point. For more info please contact our support.",
                    "linkText": "support@samsung.com",
                    "linkUrl": "support@samsung.com",
                    "automaticClaim": "We have started automatic cancellation on our side as the subscription end date is approaching. If you want to keep the device, please contact our support. Or if you want to upgrade - feel free to continue with upgrade flow."
                },
                "receipt": {
                    "title": "Swap Service Application ID {{id}} created",
                    "content": "You can view all of your ongoing Swap Service Applications and their statuses under <1>My Subscriptions</1><2>Your application will be handled within 1 business day.</2>",
                    "button": "Back Home"
                },
                "keepDisclaimerTitle": "Keeping the device",
                "keepDisclaimerContent": "If you want to keep your device, you will need to contact our support.",
                "upgradeDisclaimerLink": "Manage this subscription",
                "upgradeDisclaimerTitle": "Do you want to Upgrade and change your device?",
                "upgradeDisclaimerContent": "If you want to upgrade your device, you will need to return to subsciption manage page.",
                "stateChoice": {
                    "title": "Would you like to keep, return or upgrade the device?",
                    "returnDevice": "I would like to return the device",
                    "keepDevice": "I would like to keep the device",
                    "upgradeDevice": "I would like to upgrade the device"
                },
                "invoicesDisclaimerTitle": "Outstanding invoices",
                "invoicesDisclaimerContent": "You have unpaid invoices, please note that all invoices need to be payed before cancel is finalized.",
                "errors": {
                    "frontSideDamageFiles": "Please upload a photo of the front of the device",
                    "backSideDamageFiles": "Please upload a photo of the back of the device"
                },
                "claimStatus": {
                    "pending": "Cancellation submitted",
                    "approved": "Cancellation approved",
                    "declined": "Cancellation declined",
                    "completed": "Cancellation completed",
                    "sent": "Return Kit Sent",
                    "waitingForPayment": "Has outstanding invoices",
                    "paymentReceived": "Payment received",
                    "deviceReceived": "Device received",
                    "deviceReceivedDamaged": "Device received damaged"
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Do you want to cancel your subscription?",
                        "content": [
                            "When the time comes for you to part from your Samsung Galaxy you will need to delete all of your information on the device and remove your Google account.",
                            "Remember, if you have got any discounts, for example if you have traded in your old device, that discount will not be paid out to you and will be lost.",
                            "If your device have been damaged and you haven`t ordered a Swap Service yet, Foxway will invoice you the same amount as the Swap Service would have cost."
                        ],
                        "stepsTitle": "Here`s how it works",
                        "steps": [
                            "Click \"<strong>Cancel Subscription</strong>\"",
                            "Verify the current status of your device, (damaged or not)",
                            "Accept Terms",
                            "Click \"<strong>Cancel Subscription</strong>\""
                        ],
                        "action": "Cancel Subscription",
                        "eligibleNotificationText": "In order to cancel your contract during the first {{days}} days, please contact Samsung."
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Do you want to cancel your subscription?",
                        "content": [
                            "When the time comes for you to part from your Samsung Galaxy you will need to delete all of your information on the device and remove your Google account.",
                            "Remember, if you have got any discounts, for example if you have traded in your old device, that discount will not be paid out to you and will be lost.",
                            "If your device have been damaged and you haven`t ordered a Swap Service yet, Foxway will invoice you the same amount as the Swap Service would have cost."
                        ],
                        "stepsTitle": "Here`s how it works",
                        "steps": [
                            "Click \"<strong>Cancel Subscription</strong>\"",
                            "Verify the current status of your device, (damaged or not)",
                            "Accept Terms",
                            "Click \"<strong>Cancel Subscription</strong>\""
                        ],
                        "action": "Cancel Subscription",
                        "eligibleNotificationText": "In order to cancel your contract during the first {{days}} days, please contact Samsung."
                    }
                },
                "disclaimer": {
                    "flex": {
                        "title": "When cancelling your flex subscription you'll: ",
                        "content": [
                            "<strong>Reset</strong> your device to Factory Settings, delete all your information and remove Google lock.",
                            "<strong>Lose all potential discounts.</strong> Outstanding discounts will not be paid out to you.",
                            "<strong>Return the device</strong> in working condition. If your Samsung Galaxy is damaged Foxway will invoice a limited damage fee."
                        ]
                    },
                    "value": {
                        "title": "When cancelling your 24 month subscription you'll: ",
                        "content": [
                            "<strong>Reset</strong> your device to Factory Settings, delete all your information and remove Google lock.",
                            "<strong>Lose all potential discounts.</strong> Outstanding discounts will not be paid out to you.",
                            "<strong>Return the device</strong> in working condition. If your Samsung Galaxy is damaged Foxway will invoice a limited damage fee."
                        ]
                    }
                },
                "formTitle": "Few details before you can go",
                "conditionChoice": "How's the device condition?",
                "conditionsButton": "Show more",
                "noDamage": "The device is working and has no damages.",
                "noDamageDescription": "If your device appears damaged upon return, You’ll be invoiced with a limited damage fee.",
                "hasDamage": "The device is damaged.",
                "hasDamageDescription": "The device has a broken front display, has damage to the back side or back screen, Front or rear camera not working, photo/video quality issue, the microphone or speaker does not work, sound distortion. Battery drains quickly, slow performance, unresponsive touch screen, connectivity issues.",
                "damageTitle": "Describe the issue with the device",
                "damageAdditionalTitle": "Please have the photos of the damage (front, back, and open view) on hand. You can upload them below.",
                "damageDate": "When did this happen?",
                "damageDatePlaceholder": "Select a date",
                "nextMonth": "Next month",
                "prevMonth": "Previous month",
                "damageDescription": "Describe the issue with the device",
                "damageDescriptionPlaceholder": "Details of how it happened",
                "damageSpecTitle": "Please describe the device damage, choose as many as apply",
                "termsLabel": "I have fully read and understand the terms and conditions and lorem ipsum",
                "submitButton": "Cancel the subscription",
                "damageType": {
                    "placeholder": "Choose an option",
                    "fellAndBroke": "Device fell and broke",
                    "stoppedWorking": "Device stopped working",
                    "lostOrStolen": "I lost my device or it was stolen"
                },
                "specificDamage": {
                    "frontScreen": "Front screen damage",
                    "frontScreenDescription": "The device has a broken front display",
                    "frontScreenAddFile": "Upload photos",
                    "frontScreenFile": "Front screen damage",
                    "frontScreenRemove": "Remove front screen photos",
                    "backSide": "Back side damages",
                    "backSideDescription": "The device has damage to the back side or back screen",
                    "backSideAddFile": "Upload photos",
                    "backSideFile": "Back screen damage",
                    "backSideRemove": "Remove back screen image",
                    "camera": "Camera problem",
                    "cameraDescription": "Front or rear camera not working photo/video quality issue",
                    "audio": "Audio problem",
                    "audioDescription": "The microphone or speaker does not work, sound distortion issues",
                    "network": "Network problem",
                    "networkDescription": "The device has problems connecting to the network",
                    "power": "ON/OFF problem",
                    "powerDescription": "Can not switch device on or off",
                    "other": "Other",
                    "otherDescription": "The device has another kind of damage",
                    "otherDescriptionLabel": "Please describe the damage in detail",
                    "otherDescriptionPlaceholder": "Describe the damage"
                },
                "notSupportedNotificationTitle": "Loss of device is not covered by Swap Service, cost will vary depending on device.",
                "notSupportedNotificationContent": "Register lost device in order to get an offer from Foxway for replacement device.",
                "warrantyNotificationTitle": "Seems like your issue is covered by warranty",
                "warrantyNotificationContent": "Description",
                "upsell": {
                    "title": "Swap Service",
                    "content": "Do you want to use the Swap Service instead of cancelling your subscription?",
                    "options": {
                        "swap-device": "Is your device damaged? Perhaps you want to use the Swap Service and keep using Samsung Flex.",
                        "cancel-sub": "I want to cancel my subscription.",
                        "upgrade-device": "I would like to upgrade the device."
                    },
                    "confirmButton": "Confirm",
                    "closeButton": "Close"
                }
            },
            "upgrade": {
                "unavailableNotification": {
                    "title": "Upgrading your subscription",
                    "content": "Your subscription is not eligible for cancellation at this point. For more info please contact our support.",
                    "linkText": "support@samsung.com",
                    "linkUrl": "support@samsung.com"
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Do you want to Upgrade and change your device?",
                        "action": "Upgrade Now",
                        "url": "https://samsung.com",
                        "content": [
                            "Have you found a new favourite?Then you have come to the right place. If you are using Samsung Flex Full Flexibility you can upgrade your device whenever you want to and if you are using 24 months you can upgrade every other year."
                        ],
                        "stepsTitle": "Step by step guide how to upgrade",
                        "steps": [
                            "Check if you are eligible for an upgrade. You can find this information below. If you are using Full Flexibility you can choose to upgrade and change device whenever you want.",
                            "Click <strong>\"Upgrade\"</strong>",
                            "<strong>Choose your new device</strong> at <a href=\"samsung.com\">Samsung.com</a>",
                            "Click <strong>\"Buy Now\"</strong>",
                            "Confirm your order"
                        ]
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Do you want to Upgrade and change your device?",
                        "action": "Upgrade Now",
                        "url": "https://samsung.com",
                        "content": [
                            "Have you found a new favourite?Then you have come to the right place. If you are using Samsung Flex Full Flexibility you can upgrade your device whenever you want to and if you are using 24 months you can upgrade every other year."
                        ],
                        "stepsTitle": "Step by step guide how to upgrade",
                        "steps": [
                            "Check if you are eligible for an upgrade. You can find this information below. If you are using Full Flexibility you can choose to upgrade and change device whenever you want.",
                            "Click <strong>\"Upgrade\"</strong>",
                            "<strong>Choose your new device</strong> at <a href=\"samsung.com\">Samsung.com</a>",
                            "Click <strong>\"Buy Now\"</strong>",
                            "Confirm your order"
                        ]
                    }
                }
            },
            "swap": {
                "unavailableNotification": {
                    "title": "Swap your subscription",
                    "content": "Your subscription is not eligible for cancellation at this point. For more info please contact our support.",
                    "linkText": "support@samsung.com",
                    "linkUrl": "support@samsung.com"
                },
                "receipt": {
                    "title": "Swap Service Application ID {{id}} created",
                    "content": "You can view all of your ongoing Swap Service Applications and their statuses under <1>My Subscriptions</1><2>Your application will be handled within 1 business day.</2>",
                    "button": "Back Home"
                },
                "paymentSuccess": {
                    "title": "Swap Service Application ID {{id}} created and paid",
                    "content": "You can view all of your ongoing Swap Service Applications and their statuses under <1>My Subscriptions</1><2>Your application will be handled within 1 business day.</2>",
                    "button": "Back Home"
                },
                "paymentError": {
                    "title": "Swap Service Application ID {{id}} created but payment failed",
                    "content": "To complete the swap service please completed the payment",
                    "button": "Pay"
                },
                "title": "Swap Service",
                "bolttech": {
                    "title": "Create Insurance Case",
                    "deviceDamagedConditionTerms": "<0>If the device is damaged or lost, you must compensate Lisa& for the damage caused. Samsung Flex includes the Samsung Care+ insurance, which covers accidental drop and water damage, and an insurance claim should be filed in such cases. For certain other damages, Samsung's warranty may apply.</0><1>Fill out the form to get help identifying the best way to resolve your issue.</1>",
                    "submitButton": "Continue",
                    "continueButton": "Continue",
                    "fellAndBrokeNotificationTitle": "Your damage is of the type normally covered by Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Continue to create an insurance case with the insurance company.",
                    "lostOrStolenNotificationTitle": "Your issue is not covered by the insurance, but may be covered by the warranty.",
                    "lostOrStolenNotificationContent": "Contact our support for more information.",
                    "stoppedWorkingNotificationTitle": "Loss of device is not covered by the insurance.",
                    "stoppedWorkingNotificationContent": "Contact our support for more information."
                },
                "claimStatus": {
                    "pending": "Swap Service In Review",
                    "approved": "Swap Service New Device Sent",
                    "declined": "Swap Service declined",
                    "completed": "Cancellation completed",
                    "sent": "Swap Service Return Kit Sent",
                    "waitingForPayment": "Has outstanding invoices",
                    "paymentReceived": "Payment received",
                    "deviceReceived": "Device received",
                    "deviceReceivedDamaged": "Device received damaged"
                },
                "formTitle": "Tell us what happened",
                "submitButton": "Apply for Swap Service & Pay",
                "registerButton": "Register claim",
                "payButton": "Pay",
                "continueButton": "Continue",
                "damageTitle": "Describe the issue with the device",
                "damageAdditionalTitle": "Please have the photos of the damage (front, back, and open view) on hand. You can upload them below.",
                "damageDate": "When did this happen?",
                "damageDatePlaceholder": "Select a date",
                "nextMonth": "Next month",
                "prevMonth": "Previous month",
                "damageDescription": "damageDescription",
                "damageDescriptionPlaceholder": "Details of how it happened",
                "damageSpecTitle": "Please describe the device damage, choose as many as apply",
                "termsLabel": "I have fully read and understand the terms and conditions and lorem ipsum",
                "summaryTitle": "Swap Service Application Overview",
                "summary": {
                    "overview": {
                        "issues": {
                            "fell-and-broke": "Device fell and broke",
                            "lost": "Device lost or stolen"
                        }
                    },
                    "returnKitSentNotificationTitle": "Please note",
                    "returnKitSentNotificationContent": "We're going to send you a return kit to help you return the device.",
                    "returnKitSentNotificationLink": "#",
                    "returnKitSentNotificationLinkText": "Read more about it here",
                    "accordionTitle": "Swap Service Application Overview",
                    "certificateTitle": "Certificate number",
                    "productTitle": "Product",
                    "customerTitle": "Customer",
                    "periodTitle": "Subscription start date",
                    "deviceDetailsTitle": "Device Details",
                    "overviewTitle": "Overview",
                    "overviewIssueTitle": "Issue",
                    "overviewDamageDescriptionTitle": "Damage Description",
                    "overviewDateTitle": "Date",
                    "overviewDamagesTitle": "Damages",
                    "front-side": "Front side damage",
                    "back-side": "Back side damage",
                    "camera": "Camera problems",
                    "audio": "Audio problems",
                    "network": "Network problems",
                    "on-off-problem": "ON/OFF problems",
                    "other": "Other"
                },
                "notSupportedNotificationTitle": "Stolen or lost devices are not eligible for swap",
                "notSupportedNotificationContent": "Description",
                "warrantyNotificationTitle": "Seems like your issue is covered by warranty",
                "warrantyNotificationContent": "Description"
            }
        },
        "privacyPolicy": {
            "title": "Cookie & Data Consent Policy",
            "sections": [
                {
                    "title": "1. Use of Cookies and Data Processing",
                    "content": "Foxway and its partners, including our financial partner Lisa& Friends AB (registered in Sweden under company number 934431650, with its registered address at c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden), use cookies and similar technologies (\"Technologies\") to store and access information on your device.\n\nThese Technologies are essential for providing secure and functional services, including checkout processes and customer portal functionalities. By accepting cookies, you consent to the processing of your data, including sharing relevant information with Lisa& Friends AB to facilitate financial services and ensure a seamless experience. You can find more details about our data-sharing practices in our <a href=\"https://www.foxway.com/en/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a>."
                },
                {
                    "title": "2. Types of Cookies We Use",
                    "content": "We use both essential and optional cookies to improve your experience. These include:",
                    "items": [
                        "Strictly Necessary Cookies – Required for core website functionality, including security and accessibility.",
                        "Performance & Analytics Cookies – Help us analyze how our website is used to improve usability and performance.",
                        "Marketing & Advertising Cookies – Enable personalized ads and marketing campaigns, including on third-party platforms."
                    ]
                },
                {
                    "title": "3. Managing Your Cookie Preferences",
                    "content": "You can manage your cookie preferences at any time:",
                    "items": [
                        "Accept all cookies – Enables full functionality, including personalized content and marketing.",
                        "Reject non-essential cookies – Allows only strictly necessary cookies.",
                        "Customize settings – Adjust specific cookie preferences based on categories."
                    ],
                    "footer": "You can modify your consent settings anytime by clicking \"Customize Cookies\" at the bottom of our website.\n\nFor more information on how Foxway processes your data, please review our <a href=\"https://www.foxway.com/en/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a>."
                }
            ]
        },
        "sessionExpires": {
            "title": "Your session exipres in:",
            "description": "Do you want to extend the session?",
            "continueButtonText": "Continue",
            "cancelButtonText": "Logout now"
        }
    }
}
